export const INPUT_CONTAINER_CLASSES = '!mb-2'
export const INPUT_CLASSES = '!min-h-0 !h-[40px]'

export const INPUT_CONTAINER_CLASSES_SM = '!mb-2'
export const INPUT_CLASSES_SM = '!min-h-0 !h-[40px]'

export const INPUT_DATEPICKER_CONTAINER_SM = ''
export const INPUT_DATEPICKER_CLASSES_SM =
  '!w-full h-[35px] rounded-[17px] flex items-center px-[15px] text-text bg-surface jost text-[0.9rem]'
